import { html } from 'lit';
import { virtual } from 'haunted';
import { accents } from '../_lib/accents.js';
import { ColorSwitch } from '@outbook/webcomponents-color-switch';

const COLOR_LIST = accents.map(item => {
  return {
    name: item.name,
    value: item.name,
    code: item.code
  };
});

export const PrefAccent = virtual(({ accent, setAccent, literals }) => {
  function handleAccent(ev) {
    setAccent(ev.detail.value);
  }

  return html`
    <div class="flex flex-col items-center w-full">
      <p class="text-gray-900 dark:text-gray-100 mb-2">
        ${literals.accent}: ${accent}
      </p>
      ${ColorSwitch({
        items: COLOR_LIST,
        eventFn: handleAccent,
        inputName: 'pref-accent',
        selectedValue: accent
      })}
    </div>
  `;
});
